import { render, staticRenderFns } from "./vip_price.vue?vue&type=template&id=0a4d6502"
import script from "./vip_price.vue?vue&type=script&lang=js"
export * from "./vip_price.vue?vue&type=script&lang=js"
import style0 from "./vip_price.vue?vue&type=style&index=0&id=0a4d6502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports